/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	export class LeapedTrackPoint {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(point0:TrackPoint, point1:TrackPoint, ratio:number) {
			this.point0 = point0;
			this.point1 = point1;
			this.ratio = ratio;

			const inv = 1 - ratio;
			this.dateTime = inv * this.point0.getDateTime() + ratio * this.point1.getDateTime();
			this.elevation = inv * this.point0.getElevation() + ratio * this.point1.getElevation();
			this.elapsedTime = inv * this.point0.getElapsedTime() + ratio * this.point1.getElapsedTime();
			this.distance = inv * this.point0.getDistance() + ratio * this.point1.getDistance();

			const pixel0 = this.point0.getPosition().getPixel();
			const pixel1 = this.point1.getPosition().getPixel();
			this.pixelPosition = new THREE.Vector2(inv * pixel0.x + ratio * pixel1.x, inv * pixel0.y + ratio * pixel1.y);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getPoint0():TrackPoint {
			return this.point0;
		}

		public getPoint1():TrackPoint {
			return this.point1;
		}

		public getRatio():number {
			return this.ratio;
		}

		public getDateTime():number {
			return this.dateTime;
		}

		//public getPosition():LatLng {
		//	return this.position;
		//}

		public getElevation():number {
			return this.elevation;
		}

		public getElapsedTime():number {
			return this.elapsedTime;
		}

		//public getElapsedTimeRatio():number {
		//	return this.elapsedTimeRatio;
		//}

		public getDistance():number {
			return this.distance;
		}

		//public getDistanceRatio():number {
		//	return this.distanceRatio;
		//}

		public getPixelPosition():THREE.Vector2 {
			return this.pixelPosition;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private point0:TrackPoint;
		private point1:TrackPoint;

		private ratio:number;

		//private position:LatLng;
		private elevation:number;

		private dateTime:number;

		private elapsedTime:number;
		//private elapsedTimeRatio:number;

		private distance:number;
		//private distanceRatio:number;

		private pixelPosition:THREE.Vector2;
	}
}
